import {
  call, put, all, takeEvery
} from 'redux-saga/effects';
import _ from 'lodash';
import agreementApi from '../../externals/agreementProxy';
import workspaceApi from '../../externals/workspaceProxy';
import vendorApi from '../../externals/vendorProxy';

import {
  UNABLE_TO_LOAD_AGREEMENT_DATA,
  UNABLE_TO_LOAD_VENDORS,
  UNABLE_TO_LOAD_BUSINESS_CENTERS,
  UNABLE_TO_LOAD_SAS_FD_DETAILS,
  UNABLE_TO_SAVE_DETAILS,
  FILE_IMPORT_ERROR,
  AGREEMENT_NUMBERS_NOT_FOUND,
  UNABLE_TO_LOAD_EXCEPTIONS,
  AGREEMENT_NUMBERS_FETCH_FAILED,
  AGREEMENT_UPDATE_FAILED,
  AGREEMENT_CREATE_FAILED,
  AGREEMENT_RECALCULATE_FAILED,
  AGREEMENT_RECALCULATION_DECLINE_FAILED,
  AGREEMENT_DELETE_FAILED,
  UNABLE_TO_POST_COMMENT,
  AGREEMENT_DATA_NOT_FOUND,
  ITEM_GROUPS_NOT_FOUND,
  ITEM_GROUPS_FETCH_ERROR,
  ITEM_GROUP_FETCH_ERROR,
  VENDOR_ITEMS_FETCH_ERROR,
  ITEM_GROUP_CREATE_ERROR,
  ITEM_GROUP_UPDATE_ERROR,
  ITEM_GROUP_DELETE_ERROR,
  AGREEMENT_CLONE_FAILED,
  EXCEPTIONS_SAVE_FAILED,
  EXCEPTIONS_DELETE_ERROR,
  UNABLE_TO_LOAD_EXCEPTION_CODES,
  UNABLE_TO_PERSIST_RECALCULATION_COMMENT,
} from '../../helpers/messageConstant';
import {
  receiveErrorInVendorsFetch,
  receiveErrorInBusinessCentersFetch,
  receiveErrorInSASFDDetailsFetch,
  receiveErrorWhenSavingVendorSASDetails,
  receiveErrorWhenAddingVendorSASDetails,
  receiveErrorInSASFDFileImport,
  receiveErrorWhenSavingItemSasFdDetails,
  receiveErrorInAgreementNumbers,
  receiveErrorInAgreementDetails,
  receiveErrorInAgreementUpdate,
  receiveErrorInAgreementCreate,
  receiveErrorInAgreementRecalculate,
  receiveErrorInAgreementRecalculationDecline,
  receiveErrorInAgreementDelete,
  receiveErrorInAgreementsSearchDataFetch,
  receiveErrorInPostingComment,
  receiveErrorInAgreementClone,
  receiveErrorInExceptions,
  receiveExceptionsSaveError,
  receiveExceptionsDeleteError,
  receiveErrorInExceptionCodes,
} from '../actions/errorDialogActions';
import {
  FETCH_AGREEMENT_DATA,
  REQUEST_AGREEMENT_NUMBERS,
  REQUEST_AGREEMENT_DETAILS,
  FETCH_ITEM_GROUPS,
  FETCH_EXCEPTIONS,
  receiveWhseExceptions,
  receiveOpcoExceptions,
  receiveItemGroups,
  receiveErrorInItemGroups,
  receiveAgreementData,
  FETCH_VENDOR_BASES,
  FETCH_AGREEMENT_ASSOCIATED_VENDORS,
  receiveVendorBases,
  FETCH_BUSINESS_CENTERS,
  receiveBusinessCenters,
  FETCH_SAS_FD_DETAILS,
  receiveSASFDDetails,
  SAVE_SAS_VALUE_FOR_VENDOR,
  receiveSASValueUpdateStatus,
  ADD_SAS_VALUE_FOR_VENDOR,
  REQUEST_SAS_FD_FILE_IMPORT,
  receiveSASFDFileImport,
  receiveSASValueAddStatus,
  SAVE_SAS_FD_DETAILS_FOR_ITEM,
  receiveSasFdDetailsForItems,
  receiveAgreementNumbers,
  receiveAgreementDetails,
  UPDATE_AGREEMENT,
  receiveAgreementUpdateResponse,
  CREATE_AGREEMENT,
  receiveAgreementCreateResponse,
  requestAgreementDetails,
  RECALCULATE_AGREEMENT,
  receiveRecalculateResponse,
  DECLINE_RECALCULATION,
  receiveRecalcDeclineResponse,
  DELETE_AGREEMENT,
  receiveAgreementDeleteResponse,
  POST_AGREEMENT_COMMENT,
  receiveCommentWithAttachment,
  receiveErrorInAgreementFetch,
  FETCH_AGREEMENTS_SEARCH_DATA,
  receiveAgreementsSearchData,
  receiveErrorInItemGroupFetch,
  receiveItemGroup,
  FETCH_VENDOR_ITEMS,
  receiveVendorItems,
  receiveErrorInVendorItemsFetch,
  UPDATE_ITEM_GROUP,
  requestItemGroup,
  REQUEST_ITEM_GROUP,
  receiveItemGroupUpdateResponse,
  receiveItemGroupUpdateError,
  CREATE_ITEM_GROUPS,
  receiveItemGroupCreateResponse,
  receiveItemGroupCreateError,
  requestItemGroups,
  DELETE_ITEM_GROUP,
  receiveItemGroupDeleteResponse,
  receiveItemGroupDeleteError,
  CLONE_AGREEMENT,
  receiveAgreementCloneResponse,
  resetAgreementNumbers,
  resetAgreementDetails,
  SAVE_EXCEPTIONS,
  receiveExceptionsSaveResponse,
  DELETE_EXCEPTIONS,
  receiveExceptionsDeleteResponse,
  FETCH_EXCEPTION_CODES,
  receiveExceptionCodes,
  resetAgreementData,
} from '../actions/agreementActions';
import { FILE_TYPES, HOUSE_INDICATOR } from '../../helpers/constants';
import { assignSelectedVendors } from '../actions/vendorActions';
/**
 * Agreement Saga Class
 * @author skit1169
 */
export function* fetchAgreementData({ data }) {
  try {
    const agreementData = yield call(agreementApi.fetchAgreementSearchData, data);
    const agreementDataMap = {};
    agreementDataMap[data.key] = agreementData;
    yield put(receiveAgreementData(agreementDataMap));
  } catch (e) {
    yield put(receiveErrorInAgreementFetch(UNABLE_TO_LOAD_AGREEMENT_DATA));
  }
}

export function* fetchAgreementsSearchData({ data }) {
  try {
    const agreementsSearchData = yield call(agreementApi.fetchAgreementsSearchData, data);
    yield put(receiveAgreementsSearchData(agreementsSearchData));
  } catch (e) {
    yield put(receiveErrorInAgreementsSearchDataFetch(UNABLE_TO_LOAD_AGREEMENT_DATA));
  }
}

export function* fetchVendorBases() {
  try {
    const vendorBases = yield call(agreementApi.fetchVendorBases);
    yield put(receiveVendorBases(vendorBases));
  } catch (e) {
    yield put(receiveErrorInVendorsFetch(UNABLE_TO_LOAD_VENDORS));
  }
}

export function* fetchBusinessCenters({ data }) {
  try {
    const businessCenters = yield call(agreementApi.fetchBusinessCenters, data);
    yield put(receiveBusinessCenters(businessCenters));
  } catch (e) {
    yield put(receiveErrorInBusinessCentersFetch(UNABLE_TO_LOAD_BUSINESS_CENTERS));
  }
}

export function* fetchSASFDDetails({ data }) {
  try {
    const sasFDDetails = yield call(agreementApi.fetchSASFDDetails, data);
    yield put(receiveSASFDDetails(sasFDDetails));
  } catch (e) {
    yield put(receiveErrorInSASFDDetailsFetch(UNABLE_TO_LOAD_SAS_FD_DETAILS));
  }
}

export function* saveSASValueForVendor({ data }) {
  try {
    const response = yield call(agreementApi.updateSASValueDetails, data);
    yield put(receiveSASValueUpdateStatus(response));
  } catch (e) {
    const errorMessage = e.response.data ? e.response.data : UNABLE_TO_SAVE_DETAILS;
    yield put(receiveErrorWhenSavingVendorSASDetails(errorMessage));
  }
}

export function* importSASFDFile({ data }) {
  try {
    yield call(agreementApi.importSASFDFile, data);
    yield put(receiveSASFDFileImport('Successfully submitted the SAS/FD file to process'));
  } catch (e) {
    yield put(receiveErrorInSASFDFileImport(FILE_IMPORT_ERROR));
  }
}

export function* addSASValueForVendor({ data }) {
  try {
    const response = yield call(agreementApi.addSASValueDetails, data);
    yield put(receiveSASValueAddStatus(response));
  } catch (e) {
    const errorMessage = e.response.data ? e.response.data : UNABLE_TO_SAVE_DETAILS;
    yield put(receiveErrorWhenAddingVendorSASDetails(errorMessage));
  }
}

export function* saveSasFdDetailsForItems({ data }) {
  try {
    const response = yield call(agreementApi.updateSasFdDetails, data);
    yield put(receiveSasFdDetailsForItems(response));
  } catch (e) {
    const errorMessage = e.response.data ? e.response.data : UNABLE_TO_SAVE_DETAILS;
    yield put(receiveErrorWhenSavingItemSasFdDetails(errorMessage));
  }
}

export function* fetchAgreementNumbers({ data }) {
  try {
    const agreementNumbers = yield call(agreementApi.fetchAgreementNumbers, data);
    if (agreementNumbers.length === 0) {
      yield put(receiveErrorInAgreementNumbers(AGREEMENT_NUMBERS_NOT_FOUND));
    } else {
      yield put(receiveAgreementNumbers(agreementNumbers));
    }
  } catch (e) {
    yield put(receiveErrorInAgreementNumbers(AGREEMENT_NUMBERS_FETCH_FAILED));
  }
}

export function* fetchAgreementDetails({ data }) {
  try {
    const agreementResponse = yield call(agreementApi.fetchAgreementDetails, data);
    if (agreementResponse.error) yield put(receiveErrorInAgreementDetails(AGREEMENT_DATA_NOT_FOUND));
    else {
      const legacyReferenceResponse = yield call(agreementApi.fetchAgreementLegacyReference, data);
      const allVendorsResponse = yield call(vendorApi.fetchAllVendors);

      const agreementSuvc = agreementResponse.agreementHeader?.suvc?.code;
      const allAgreementSuvcVendors = allVendorsResponse.suvcs.find((suvc) => suvc.code === agreementSuvc)?.vendors;
      const assignSelectedVendorData = {
        allSuvcVendors: allAgreementSuvcVendors,
        suvc: agreementResponse.agreementHeader?.suvc,
        vendors: agreementResponse.agreementHeader?.vendors
      };

      agreementResponse.legacyReference = legacyReferenceResponse;
      agreementResponse.allSuvcVendors = allAgreementSuvcVendors;
      yield all([put(receiveAgreementDetails(agreementResponse)), put(assignSelectedVendors(assignSelectedVendorData))]);
    }
  } catch (e) {
    yield put(receiveErrorInAgreementDetails(UNABLE_TO_LOAD_AGREEMENT_DATA));
  }
}

export function* updateAgreement({ data }) {
  try {
    const response = yield call(agreementApi.updateAgreement, data);
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveAgreementUpdateResponse(response));
  } catch (e) {
    yield put(receiveErrorInAgreementUpdate(e.response?.data || AGREEMENT_UPDATE_FAILED));
  }
}

export function* cloneAgreement({ data }) {
  let agreementCloneResponse;
  try {
    agreementCloneResponse = yield call(agreementApi.cloneAgreement, data);
    const agreementFetchResponse = yield call(agreementApi.fetchAgreementDetails, agreementCloneResponse);
    const legacyReferenceResponse = yield call(agreementApi.fetchAgreementLegacyReference, agreementCloneResponse);
    agreementFetchResponse.legacyReference = legacyReferenceResponse;
    yield all([put(receiveAgreementCloneResponse(agreementCloneResponse)), put(resetAgreementNumbers()), put(receiveAgreementDetails(agreementFetchResponse))]);
  } catch (e) {
    if (_.isEmpty(agreementCloneResponse)) yield put(receiveErrorInAgreementClone(AGREEMENT_CLONE_FAILED));
    else yield all([put(receiveAgreementCloneResponse(agreementCloneResponse)), put(resetAgreementDetails())]);
  }
}

export function* createAgreement({ data }) {
  try {
    const response = yield call(agreementApi.createAgreement, data);
    yield put(requestAgreementDetails({ agreementId: response.agreementId }));
    yield put(resetAgreementData());
    yield put(receiveAgreementCreateResponse(response));
  } catch (e) {
    yield put(receiveErrorInAgreementCreate(AGREEMENT_CREATE_FAILED));
  }
}

export function* recalculateAgreement({ data }) {
  let response;
  try {
    const { recalculateRequest, comment, agreementId } = data;
    response = yield call(workspaceApi.submitWorkspaceRequest, recalculateRequest);
    yield call(agreementApi.recalculateAgreement, { agreementId, comment });
    yield put(requestAgreementDetails({ agreementId }));
    yield put(receiveRecalculateResponse(response));
  } catch (e) {
    if (e.message === UNABLE_TO_PERSIST_RECALCULATION_COMMENT) yield put(receiveRecalculateResponse(response));
    else yield put(receiveErrorInAgreementRecalculate(AGREEMENT_RECALCULATE_FAILED));
  }
}

export function* declineRecalculation({ data }) {
  try {
    const response = yield call(agreementApi.declineRecalculation, data);
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveRecalcDeclineResponse(response));
  } catch (e) {
    yield put(receiveErrorInAgreementRecalculationDecline(AGREEMENT_RECALCULATION_DECLINE_FAILED));
  }
}

export function* deleteAgreement({ data }) {
  try {
    const { agreementId } = data;
    const response = yield call(agreementApi.deleteAgreement, data);
    yield put(requestAgreementDetails({ agreementId }));
    yield put(receiveAgreementDeleteResponse(response));
  } catch (e) {
    yield put(receiveErrorInAgreementDelete(AGREEMENT_DELETE_FAILED));
  }
}

export function* postAgreementComment({ data }) {
  const params = { ...data };
  try {
    if (data.attachments.length > 0) {
      const attachments = yield call(workspaceApi.uploadWorkspaceAttachments, FILE_TYPES.GENERAL_WORKSPACE_ATTACHMENT, data.attachments);
      params.attachments = attachments;
    }
    yield put(receiveCommentWithAttachment(params));
  } catch (e) {
    yield put(receiveErrorInPostingComment(UNABLE_TO_POST_COMMENT));
  }
}

export function* fetchAgreementAssociatedVendors({ data }) {
  try {
    const vendorBases = yield call(agreementApi.fetchAgreementAssociatedVendors, data);
    yield put(receiveVendorBases(vendorBases));
  } catch (e) {
    yield put(receiveErrorInVendorsFetch(UNABLE_TO_LOAD_VENDORS));
  }
}

export function* fetchItemGroups({ data }) {
  try {
    const itemGroupList = yield call(agreementApi.fetchItemGroups, data);
    yield put(receiveItemGroups(itemGroupList));
  } catch (e) {
    if (e.message.includes('404')) {
      yield put(receiveErrorInItemGroups(ITEM_GROUPS_NOT_FOUND));
    } else {
      yield put(receiveErrorInItemGroups(ITEM_GROUPS_FETCH_ERROR));
    }
  }
}

export function* fetchItemGroup({ data }) {
  try {
    const itemGroup = yield call(agreementApi.fetchItemGroup, data);
    if (itemGroup.error) yield put(receiveErrorInItemGroupFetch(ITEM_GROUP_FETCH_ERROR));
    else {
      let legacyReferenceResponse;
      try {
        legacyReferenceResponse = yield call(agreementApi.fetchItemGroupLegacyReference, data.itemGroupId);
      } catch (legacyRefError) {
        if (data.version) {
          legacyReferenceResponse = [];
        } else {
          throw legacyRefError;
        }
      }

      itemGroup.legacyReference = legacyReferenceResponse;
      yield put(receiveItemGroup(itemGroup));
    }
  } catch (e) {
    yield put(receiveErrorInItemGroupFetch(ITEM_GROUP_FETCH_ERROR));
  }
}

export function* fetchVendorItems({ data }) {
  try {
    const vendorItems = yield call(agreementApi.fetchVendorItems, data);
    yield put(receiveVendorItems(vendorItems));
  } catch (e) {
    yield put(receiveErrorInVendorItemsFetch(VENDOR_ITEMS_FETCH_ERROR));
  }
}

export function* updateItemGroup({ data }) {
  try {
    const response = yield call(agreementApi.updateItemGroup, data);
    yield put(requestItemGroup({ itemGroupId: data.itemGroup }));
    yield put(requestItemGroups({ agreementId: data.agreementId }));
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveItemGroupUpdateResponse(response));
  } catch (e) {
    const errorMessage = e.response.data ? e.response.data : ITEM_GROUP_UPDATE_ERROR;
    yield put(receiveItemGroupUpdateError(errorMessage));
  }
}

export function* createItemGroups({ data }) {
  try {
    const response = yield call(agreementApi.createItemGroups, data);
    yield put(requestItemGroups({ agreementId: data.agreementId }));
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveItemGroupCreateResponse(response));
  } catch (e) {
    const errorMessage = e.response.data ? e.response.data : ITEM_GROUP_CREATE_ERROR;
    yield put(receiveItemGroupCreateError(errorMessage));
  }
}

export function* deleteItemGroup({ data }) {
  try {
    const response = yield call(agreementApi.deleteItemGroup, data);
    yield put(requestItemGroups({ agreementId: data.agreementId }));
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveItemGroupDeleteResponse({ response, itemGroup: data.itemGroup }));
  } catch (e) {
    const errorMessage = e.response.data ? e.response.data : ITEM_GROUP_DELETE_ERROR;
    yield put(receiveItemGroupDeleteError(errorMessage));
  }
}

export function* fetchExceptions({ data }) {
  try {
    const { houseIndicator } = data;
    const exceptions = yield call(agreementApi.fetchExceptions, data);
    if (houseIndicator === HOUSE_INDICATOR.WAREHOUSE) {
      yield put(receiveWhseExceptions(exceptions));
    } else {
      yield put(receiveOpcoExceptions(exceptions));
    }
  } catch (e) {
    yield put(receiveErrorInExceptions(UNABLE_TO_LOAD_EXCEPTIONS));
  }
}

export function* saveExceptions({ data }) {
  try {
    const response = yield call(agreementApi.saveExceptions, data);
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveExceptionsSaveResponse(response));
  } catch (e) {
    yield put(receiveExceptionsSaveError(e.response?.data || EXCEPTIONS_SAVE_FAILED));
  }
}

export function* deleteExceptions({ data }) {
  try {
    const response = yield call(agreementApi.deleteExceptions, data);
    yield put(requestAgreementDetails({ agreementId: data.agreementId }));
    yield put(receiveExceptionsDeleteResponse({ response, houseIndicator: data.houseIndicator }));
  } catch (e) {
    yield put(receiveExceptionsDeleteError(e.response?.data || EXCEPTIONS_DELETE_ERROR));
  }
}

export function* fetchExceptionCodes({ data }) {
  try {
    const exceptionCodes = yield call(agreementApi.fetchExceptionCodes, data);
    yield put(receiveExceptionCodes(exceptionCodes));
  } catch (e) {
    yield put(receiveErrorInExceptionCodes(UNABLE_TO_LOAD_EXCEPTION_CODES));
  }
}

export function* agreementSaga() {
  yield takeEvery(FETCH_AGREEMENT_DATA, fetchAgreementData);
  yield takeEvery(FETCH_AGREEMENTS_SEARCH_DATA, fetchAgreementsSearchData);
  yield takeEvery(FETCH_VENDOR_BASES, fetchVendorBases);
  yield takeEvery(FETCH_AGREEMENT_ASSOCIATED_VENDORS, fetchAgreementAssociatedVendors);
  yield takeEvery(FETCH_BUSINESS_CENTERS, fetchBusinessCenters);
  yield takeEvery(FETCH_SAS_FD_DETAILS, fetchSASFDDetails);
  yield takeEvery(SAVE_SAS_VALUE_FOR_VENDOR, saveSASValueForVendor);
  yield takeEvery(REQUEST_SAS_FD_FILE_IMPORT, importSASFDFile);
  yield takeEvery(ADD_SAS_VALUE_FOR_VENDOR, addSASValueForVendor);
  yield takeEvery(SAVE_SAS_FD_DETAILS_FOR_ITEM, saveSasFdDetailsForItems);
  yield takeEvery(REQUEST_AGREEMENT_NUMBERS, fetchAgreementNumbers);
  yield takeEvery(REQUEST_AGREEMENT_DETAILS, fetchAgreementDetails);
  yield takeEvery(UPDATE_AGREEMENT, updateAgreement);
  yield takeEvery(CREATE_AGREEMENT, createAgreement);
  yield takeEvery(DELETE_AGREEMENT, deleteAgreement);
  yield takeEvery(CLONE_AGREEMENT, cloneAgreement);
  yield takeEvery(RECALCULATE_AGREEMENT, recalculateAgreement);
  yield takeEvery(DECLINE_RECALCULATION, declineRecalculation);
  yield takeEvery(POST_AGREEMENT_COMMENT, postAgreementComment);
  yield takeEvery(FETCH_ITEM_GROUPS, fetchItemGroups);
  yield takeEvery(REQUEST_ITEM_GROUP, fetchItemGroup);
  yield takeEvery(FETCH_VENDOR_ITEMS, fetchVendorItems);
  yield takeEvery(UPDATE_ITEM_GROUP, updateItemGroup);
  yield takeEvery(CREATE_ITEM_GROUPS, createItemGroups);
  yield takeEvery(DELETE_ITEM_GROUP, deleteItemGroup);
  yield takeEvery(FETCH_EXCEPTIONS, fetchExceptions);
  yield takeEvery(SAVE_EXCEPTIONS, saveExceptions);
  yield takeEvery(DELETE_EXCEPTIONS, deleteExceptions);
  yield takeEvery(FETCH_EXCEPTION_CODES, fetchExceptionCodes);
}
